import { Link } from 'react-router-dom';

const QUICK_LINKS = [
  { label: '最新资讯', to: '/news' },
  { label: '活动专题', to: '/events' },
  { label: '角色攻略', to: '/characters' },
  { label: '版本更新', to: '/updates' },
  { label: '关于我们', to: '/about' },
];

const HOT_TAGS = ['版本前瞻', '深渊攻略', '角色培养', '圣遗物', '元素反应', '新手入门'];

export default function Footer() {
  return (
    <footer className="mt-20 bg-primary-900 text-primary-50">
      <div className="px-4 py-14 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500">
                <i className="ri-vip-diamond-line text-lg text-primary-950"></i>
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-background-50">原神资讯站</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-primary-100/75">
              专注原神游戏资讯、活动情报、角色攻略与版本更新的综合门户，帮助每一位旅行者高效了解游戏世界。
            </p>
            <div className="mt-5 flex gap-2.5">
              {['ri-weibo-fill', 'ri-qq-fill', 'ri-bilibili-fill', 'ri-youtube-fill'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  aria-label="社交媒体"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 text-primary-100 transition-colors hover:bg-accent-500 hover:text-primary-950"
                >
                  <i className={`${icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">
              <a href="#footer-nav">快速导航</a>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {QUICK_LINKS.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="cursor-pointer text-sm text-primary-100/75 transition-colors hover:text-accent-300">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">
              <a href="#footer-tags">热门标签</a>
            </h4>
            <div className="mt-4 flex flex-wrap gap-2">
              {HOT_TAGS.map((tag) => (
                <Link
                  key={tag}
                  to={`/search?q=${encodeURIComponent(tag)}`}
                  className="cursor-pointer rounded-full border border-primary-700 bg-primary-800/60 px-3 py-1 text-xs text-primary-100 transition-colors hover:border-accent-400 hover:text-accent-300"
                >
                  {tag}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">
              <a href="#footer-contact">联系我们</a>
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-primary-100/75">
              <li className="flex items-start gap-2">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center text-accent-300">
                  <i className="ri-mail-line"></i>
                </span>
                contact@genshin-info-demo.com
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center text-accent-300">
                  <i className="ri-map-pin-line"></i>
                </span>
                提瓦特大陆 · 蒙德城 · 冒险家协会资讯处
              </li>
            </ul>
            <Link
              to="/about"
              className="mt-5 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-label font-medium text-primary-950 transition-colors hover:bg-accent-400"
            >
              <i className="ri-send-plane-line"></i>
              意见反馈
            </Link>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-primary-100/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 原神资讯站 · 本站为演示站点，内容与图片均为虚构示例，仅用于展示目的。</p>
          <div className="flex flex-wrap gap-4">
            <Link to="/about" className="cursor-pointer transition-colors hover:text-accent-300">
              免责声明
            </Link>
            <Link to="/about" className="cursor-pointer transition-colors hover:text-accent-300">
              隐私说明
            </Link>
            <Link to="/about" className="cursor-pointer transition-colors hover:text-accent-300">
              服务条款
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}